import script from "./DeliveryMetersCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryMetersCard.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryMetersCard.vue?vue&type=style&index=0&id=173fc240&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173fc240"]])

export default __exports__